import { publicRequest } from '@/utils/request'

// 添加商品到询价单
export function addToCart(data) {
  return publicRequest({
    url: '/cart/add',
    method: 'post',
    data: data
  })
}

// 获取询价单列表
export function getCartList() {
  return publicRequest({
    url: '/cart/list',
    method: 'get'
  })
}

// 更新询价单商品数量
export function updateQuantity(id, quantity) {
  return publicRequest({
    url: '/cart/update/quantity',
    method: 'get',
    params: {
      id: id,
      quantity: quantity
    }
  })
}

// 删除询价单商品（表单提交方式）
export function deleteCartItem(ids) {
  // 使用 URLSearchParams 构建表单数据
  const formData = new URLSearchParams();
  // 如果 ids 是数组，需要将每个 id 作为单独的参数
  if (Array.isArray(ids)) {
    ids.forEach(id => {
      formData.append('ids', id);
    });
  } else {
    formData.append('ids', ids);
  }
  
  return publicRequest({
    url: '/cart/delete',
    method: 'post',
    data: formData.toString(), // 转换为字符串格式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [(data) => {
      // 确保数据以表单格式发送
      return data;
    }]
  })
}

// 清空询价单
export function clearCart() {
  return publicRequest({
    url: '/cart/clear',
    method: 'post'
  })
}




// WEBPACK FOOTER //
// ./src/api/cart.js